import React from 'react';
import ReactDOM from 'react-dom';
import Btn from './Btn';
import './style.css';
ReactDOM.render(
  < >
  <div className="align">
  <Btn/>
  <Btn/>
  <Btn/>
  <Btn/>
  </div>
  </>,
  document.getElementById("root")
);